var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-modal",
    {
      attrs: {
        "modal-class": "vue-need-bootstrap",
        "title-class": "font-weight-bold",
        "no-close-on-esc": "",
        "no-close-on-backdrop": "",
        scrollable: _vm.scrollable,
        centered: "",
        "ok-only": "",
        "dialog-class": _vm.dialogClass,
        "hide-backdrop": _vm.hideBackdrop,
        "hide-header-close": _vm.hideClose,
        "ok-title": _vm.okTitle,
        "ok-disabled": _vm.okDisabled,
        "no-enforce-focus": !_vm.autoFocus,
        title: _vm.title,
        size: _vm.size,
        "hide-footer": _vm.hideFooter,
      },
      on: {
        ok: function ($event) {
          return _setup.emit("ok")
        },
        close: function ($event) {
          return _setup.emit("closed")
        },
      },
      scopedSlots: _vm._u(
        [
          _vm._l(_setup.slots, function (_, slotName) {
            return {
              key: slotName,
              fn: function (scope) {
                return [_vm._t(slotName, null, null, scope)]
              },
            }
          }),
        ],
        null,
        true
      ),
      model: {
        value: _setup.isOpen,
        callback: function ($$v) {
          _setup.isOpen = $$v
        },
        expression: "isOpen",
      },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }